import { TFunction } from "i18next"
import { AppointmentType, Service, ServiceSpecialty } from "@/types/__generated__/union-types"

export const getProgressNoteTitle = (
  t: TFunction<"translation", undefined>,
  appointmentType: AppointmentType,
  specialty: ServiceSpecialty,
  service: Service,
): string => {
  const appointmentTypeLabel =
    appointmentType === "NORMAL" ? "" : t(`scheduling.waitingRoom.appointmentType.${appointmentType}`)
  const specialtyLabel =
    specialty === "NONE" || !specialty ? "" : t(`scheduling.waitingRoom.serviceSpecialty.${specialty}`)

  const title = `${appointmentTypeLabel} ${specialtyLabel} ${t(`scheduling.waitingRoom.service.${service}`)}`

  return title
    .split(" ")
    .filter((word) => word)
    .join(" ")
}
